@if (!stateType || stateType < stateTypeEnum.deformityAnalysis) { <div class="sidebar">
	<div class="spacing-top"></div>
	<span class="text-vertical"></span>
	</div>
	}

	@if (!isCorrectionDrawerVisible) {
	<div class="sidebar second">
		<span class="text-vertical"></span>
	</div>
	}

	<!-- DEFORMITY DRAWER -->
	<!--NOTA: aggiungere la classe "out-range" al seguente div "sidebar" quando è presente almeno un errore di "out of range" nella tabella -->
	@if (stateType && stateType >= stateTypeEnum.deformityAnalysis) {
	<div class="sidebar first-color" [class]="{'open': isDeformityDrawerOpen, 'out-range': isDeformityOutOfRange }">

		<div class="spacing-top">
			<div class="open-sidebar" (click)="isDeformityDrawerOpen = !isDeformityDrawerOpen"
				(keypress)="isDeformityDrawerOpen = !isDeformityDrawerOpen">
				<i class="material-icons">chevron_right</i>
			</div>
		</div>

		<span class="text-vertical clickable" (click)="isDeformityDrawerOpen = !isDeformityDrawerOpen"
			(keypress)="isDeformityDrawerOpen = !isDeformityDrawerOpen">
			{{ labels().DRAWER_COMPONENT_TEXT_VERTICAL_DEFORMITY }}
		</span>

		<div class="wrapper-table-accordion">

			<h3>{{ labels().DRAWER_COMPONENT_TITLE_DEFORMITY }}</h3>
			@if (hasAP) { <ma-ap-table /> }
			@if (hasAP) { <lld-table /> }
			@if (hasLT) { <ma-lt-table /> }
			<apex-table />

		</div>

	</div>
	}

	<!-- CORRECTION DRAWER -->
	@if (isCorrectionDrawerVisible) {
	<div class="sidebar second second-color"
		[class]="{'open': isCorrectionDrawerOpen, 'out-range': isCorrectionOutOfRange }">

		<div class="spacing-top">
			<div class="open-sidebar" (click)="isCorrectionDrawerOpen = !isCorrectionDrawerOpen"
				(keypress)="isCorrectionDrawerOpen = !isCorrectionDrawerOpen">
				<i class="material-icons">chevron_right</i>
			</div>
		</div>

		<span class="text-vertical clickable" (click)="isCorrectionDrawerOpen = !isCorrectionDrawerOpen"
			(keypress)="isCorrectionDrawerOpen = !isCorrectionDrawerOpen">
			{{ labels().DRAWER_COMPONENT_TEXT_VERTICAL_CORRECTION }}
		</span>

		<div class="wrapper-table-accordion">

			<h3>{{ labels().DRAWER_COMPONENT_TITLE_CORRECTION }}</h3>
			<wedge-table />
			@if (hasAP) { <ma-ap-recap /> }
			@if (hasAP) { <lld-recap /> }
			@if (hasLT) { <ma-lt-recap /> }

		</div>

	</div>
	}